import React from 'react';
import PropTypes from 'prop-types';

import PickingErrorToast from "./PickingErrorToast";
import {FormattedMessage} from "react-intl";

PickingToastManager.propTypes = {
    open: PropTypes.bool.isRequired,
    type: PropTypes.number,
    handleClose: PropTypes.func
};

export const ToastType = {
    TROLLEY_NOT_FOUND: 1,
    TROLLEY_ALREADY_TAKEN: 2,
    TROLLEY_CONTAIN_SHIPMENTS: 3
}

function PickingToastManager({open = false, type = 0, handleClose = () => {}}) {

    function getMessage() {
        switch (type) {
            case ToastType.TROLLEY_NOT_FOUND:
                return <FormattedMessage id='wms.myPickingMissions.scanTrolley.error.barcode.notValid' />
            case ToastType.TROLLEY_ALREADY_TAKEN:
                return <FormattedMessage id='wms.myPickingMissions.scanTrolley.error.trolley.alreadyTaken' />
            case ToastType.TROLLEY_CONTAIN_SHIPMENTS:
                return <FormattedMessage id='wms.myPickingMissions.scanTrolley.error.trolley.containShipments' />
            default:
                return null;
        }
    }

    return (
        <PickingErrorToast
            message={getMessage()}
            open={open}
            handleClose={handleClose}
        />
    )
}

export default PickingToastManager;
